import { jsx as _jsx } from "react/jsx-runtime";
import { getCurrentColorMode } from '../../../../../../scss/js-helpers/getCurrentColorMode';
import SmsLogoDark from '../icons/sms-logo-dark.svg';
import SmsLogoLight from '../icons/sms-logo-light.svg';
export var DefaultSquireLogo = function () {
    var colorMode = getCurrentColorMode();
    if (colorMode === 'light') {
        return _jsx(SmsLogoLight, {});
    }
    return _jsx(SmsLogoDark, {});
};
